module.exports = {"341023100":"碧阳镇","341023101":"宏村镇","341023102":"渔亭镇","341023103":"西递镇","341023104":"柯村镇","341023201":"美溪乡","341023202":"宏潭乡","341023203":"洪星乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341023.json
// module id = 1215
// module chunks = 0